import React from 'react';
import clsx from 'clsx';

interface PositionControlLineProps {
  className?: string;
  state: 'vertical' | 'horizontal';
  onClick?: () => void;
  disabled: boolean;
  value?: boolean;
}

export const PositionControlLine: React.FC<PositionControlLineProps> = ({
  className = '',
  state = 'vertical',
  onClick,
  disabled = false,
  value,
}) => {
  const handleClick = () => {
    if (!disabled) {
      if (onClick) onClick();
    }
  };

  return (
    <div
      onClick={handleClick}
      className={clsx(
        'rounded border border-neutral-200 transition-all',
        {
          'h-3.5 w-2': state === 'vertical',
          'h-2 w-3.5': state === 'horizontal',
          'bg-indigo-500': value === true && disabled === false,
          'bg-neutral-10': value === false || disabled === true,
          'cursor-default': disabled === true,
          'cursor-pointer': disabled === false,
        },
        className,
      )}
    />
  );
};
